import { Link } from 'react-router-dom';
import Logo from '@/components/layout/Logo/Logo';
import {
  BRAND_NAME,
  FAMILY_LINKS,
  OPERATOR_NAME,
  OPERATOR_URL,
  PRIVACY_URL,
  SERVICE_NAME,
  TERMS_URL,
} from '@/lib/brand';
import styles from './SiteFooter.module.css';

function ExternalIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
}

// 建築知能のサービス共通のフッター（温熱計算 LP・まどりの構造チェック LP と同じ組み方）:
// 藍地・白ロゴのロックアップ・3 列（このサービス／建築知能ファミリー／運営）・下段に規約と ©。
export default function SiteFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.top}>
        <div>
          <Logo variant="reversed" size="footer" />
          <p className={styles.note}>
            住所を入れるだけで、土地の災害リスクから暮らしやすさ、将来の見通しまでを、無料・登録不要で確認できるツールです。
            {BRAND_NAME}のサービスとして、{OPERATOR_NAME}が開発・運営しています。
          </p>
        </div>

        <div className={styles.cols}>
          <nav aria-label={SERVICE_NAME}>
            <h3>このサービスの中身</h3>
            <ul>
              <li>
                <Link to="/#how">使い方は3ステップ</Link>
              </li>
              <li>
                <Link to="/#report">何がわかる？</Link>
              </li>
              <li>
                <Link to="/#marks">判定の見方</Link>
              </li>
              <li>
                <Link to="/#faq">よくある質問</Link>
              </li>
              <li>
                <Link to="/report/sample">サンプルを見る</Link>
              </li>
            </ul>
          </nav>

          <nav aria-label={`${BRAND_NAME}ファミリー`}>
            <h3>{BRAND_NAME}ファミリー</h3>
            <ul>
              {FAMILY_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href}>{l.label}</a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3>運営 | {OPERATOR_NAME}</h3>
            <p>
              〒105-0013
              <br />
              東京都港区浜松町 1‐21‐4
              <br />
              崇城大学会館 6F
              <br />
              <a href={OPERATOR_URL} target="_blank" rel="noopener noreferrer">
                {OPERATOR_URL}
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className={styles.bottom}>
        <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">
          利用規約
          <ExternalIcon />
        </a>
        <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
          プライバシーポリシー
          <ExternalIcon />
        </a>
        <span className={styles.copyright}>© {new Date().getFullYear()} ARCHIROID Inc.</span>
      </div>
    </footer>
  );
}
